import { addHours, addMinutes } from 'date-fns';

export const generateRandomDateFrom12To72HoursForTimerex = (key: number) => {
  let x = key;
  x ^= x << 13;
  x ^= x >> 17;
  x ^= x << 5;
  // 12時間後から72時間後までなので、60時間分の30分で120
  const countOf30minutes = Math.abs(x) % 120;

  const now = new Date();
  const startingDate = addHours(
    new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours()),
    13
  );

  const d = addMinutes(startingDate, countOf30minutes * 30);
  // 9時~20時の時間
  if (d.getHours() < 9) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 9);
  }

  if (20 <= d.getHours()) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, 9);
  }

  return d;
};
